import { render } from "./FilterChips.vue?vue&type=template&id=a8964296&scoped=true"
import script from "./FilterChips.vue?vue&type=script&lang=js"
export * from "./FilterChips.vue?vue&type=script&lang=js"

import "./FilterChips.vue?vue&type=style&index=0&id=a8964296&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8964296"]])

export default __exports__